// export const SEARCH_PARAM = 'SEARCH_PARAM';
export const SET = 'SET';
export const SET_SEARCH_PARAM = 'SET_SEARCH_PARAM';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SET_CURRENT_MST_VALUE = 'SET_CURRENT_MST_VALUE';
export const SET_SEARCH_POPUP_M_PARAM = 'SET_SEARCH_POPUP_M_PARAM';
export const SET_SEARCH_POPUP_D_PARAM = 'SET_SEARCH_POPUP_D_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const STATE_POPUP_INIT = 'STATE_POPUP_INIT';
export const POPUP_DATA_MST_LIST_INIT = 'POPUP_DATA_MST_LIST_INIT';
export const POPUP_DATA_DTL_LIST_INIT = 'POPUP_DATA_DTL_LIST_INIT';
export const SEARCH_POPUP_M_PAGING_INFO = 'SEARCH_POPUP_M_PAGING_INFO';

export default {
	SET,
	SET_SEARCH_PARAM,
	DEFAULT_ASSIGN,
	SET_CURRENT_MST_VALUE,
	SET_SEARCH_POPUP_M_PARAM,
	SET_SEARCH_POPUP_D_PARAM,
	STATE_INIT,
	STATE_POPUP_INIT,
	POPUP_DATA_MST_LIST_INIT,
	POPUP_DATA_DTL_LIST_INIT,
	SEARCH_POPUP_M_PAGING_INFO
};
